import { LAYOUTS, } from "@voltmoney/types";
import { CameraPickerState, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { CameraAction, CancelCameraAction } from "./actions";
import { getParameters, getPlatformName } from "../../../configs/uri-config-utils";
import SharedPropsService from "../../../SharedPropsService";
import { Platform } from 'react-native';
import { showPhonePeSdk } from "../../../configs/utils";
export const template = (isFromPhonepe, showPhonePeSdkCamera) => ({
    layout: {
        id: ROUTE.CAMERA_CAPTURE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: "camera", type: WIDGET.CAMERA, padding: { horizontal: 0 } },
        ],
    },
    datastore: {
        camera: {
            state: CameraPickerState.ON,
            isFromPhonepe,
            showPhonePeSdkCamera,
            action: {
                type: ACTION.CAMERA_ACTION,
                routeId: ROUTE.CAMERA_CAPTURE,
                payload: { value: "" },
            },
            cancelAction: {
                type: ACTION.CANCEL_CAMERA,
                routeId: ROUTE.CAMERA_CAPTURE,
                payload: { value: "" },
            },
        },
    },
});
export const cameraCaptureMF = {
    onLoad: async () => {
        const url = SharedPropsService?.getURL();
        let params;
        let isFromPhonepe = false;
        if (Platform.OS === 'web') {
            params = getParameters(url);
            if (getPlatformName(params) === "PHONEPE" /* AppPlatform.PHONEPE */) {
                isFromPhonepe = true;
            }
            else {
                isFromPhonepe = false;
            }
        }
        const showPhonePeSdkCamera = await showPhonePeSdk();
        return Promise.resolve(template(isFromPhonepe, showPhonePeSdkCamera));
    },
    actions: {
        [ACTION.CAMERA_ACTION]: CameraAction,
        [ACTION.CANCEL_CAMERA]: CancelCameraAction,
    },
    clearPrevious: true,
};
